import axios from 'axios';
// import sessionService from 'services/session'
import {SessionService} from 'services/SessionService'
import ses from "services/session";
import { getBaseApi } from "./services/BaseApi";


let session = new SessionService();

let restApi = axios.create({
    baseURL: getBaseApi(),
    // baseURL: 'http://localhost:8080/api/',
    // baseURL: 'https://terminmasterapi.in.rs/api/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': ses.getLocale(),
        'Access-Control-Allow-Origin': '*'
    }
});

restApi.interceptors.request.use(function (config) {
    config.baseURL = getBaseApi();
    return config;
}, function (error) {
    return Promise.reject(error);
});

restApi.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        let status = error.response != null ? error.response.status : null;
        if (isWodProgramWithToken() && (status === 401 || status === 403)) {
            return Promise.reject(error.response);
        }
        if ((status === 401 || status === 403) && !window.location.href.includes('login')) {
            return session.handleErrorResponse(error);
        }else if((status === 401 || status === 403) && window.location.href.includes('login')){
            return session.handleLoginErrorResponse(error)
        }else if(status === 409 && error.response.data.error_description.includes('Morate da prihvatite uslove')){
            return session.handleAcceptTermsErrorResponse(error)
        } else {
            return Promise.reject(error.response);
        }
    }
);

function isWodProgramWithToken() {
    return window.location.href.includes('wod-program') && window.location.href.includes('programToken');
}

export default restApi



// WEBPACK FOOTER //
// ./src/http-common.js